














import {Component, Prop, Vue} from 'vue-property-decorator';
import Address from "@/api/Address";

@Component
export default class RenderAddressSummary extends Vue {
  @Prop() private address!: Address;

  getTrimmedStreet(): string{
    if(this.address.street) {
      return this.address.street.substring(0, 25);
    }
    return "";
  }
}
